export default __webpack_public_path__ + "static/media/s1.36ab031c.svg";